// extracted by mini-css-extract-plugin
export default {"btn_submit":"FormInput_btn_submit__4XgMq","file-upload":"FormInput_file-upload__ExwNs","upload":"FormInput_upload__zyKD8"};